import { api } from "@/lib/api-client"

import { AuthUserResponse } from "../types/api"
import { LoginRequest } from "../types/form"

export const loginWithEmailAndPassword = (
  data: LoginRequest
): Promise<AuthUserResponse> => {
  return api.post("/auth", data)
}
